import api from "../api";

const cancelInvoice = async ({ storeCode, invoiceNumber, reason }) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/management/stores/${encodeURIComponent(
    storeCode
  )}/invoices/${encodeURIComponent(invoiceNumber)}/cancel`;
  const response = await api.post(endpoint, {
    reason,
  });
  return response.data;
};

export default cancelInvoice;
